import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'rsf-main-s1-checkcard',
  templateUrl: './rsf-main-s1-checkcard.component.html',
  styleUrls: ['./rsf-main-s1-checkcard.component.scss']
})
export class RsfMainS1CheckcardComponent {
  @Input() title?: string;
  @Input() control!: FormControl;
  @Input() hilite?: boolean;


  @Output() changed = new EventEmitter<boolean>();
}
